import type { AsyncSequence } from "../types/AsyncSequence"

export async function* FilterAsync<T>(
  func: (item: T, index: number) => boolean | Promise<boolean>,
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<T> {
  let index = 0
  for (const array of arrays) {
    for await (const item of array) {
      if (await func(item, index++)) {
        yield item
      }
    }
  }
}
